import { render } from "./oportunidades.vue?vue&type=template&id=36f5d5fa"
import script from "./oportunidades.vue?vue&type=script&lang=js"
export * from "./oportunidades.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__